import { render, staticRenderFns } from "./ModalQuizResult.vue?vue&type=template&id=714cf9ec&scoped=true"
import script from "./ModalQuizResult.vue?vue&type=script&lang=js"
export * from "./ModalQuizResult.vue?vue&type=script&lang=js"
import style0 from "./ModalQuizResult.vue?vue&type=style&index=0&id=714cf9ec&prod&lang=scss&scoped=true"
import style1 from "./ModalQuizResult.vue?vue&type=style&index=1&id=714cf9ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714cf9ec",
  null
  
)

export default component.exports